module.exports = __webpack_public_path__ + "img/gsk_logo.fbeb3407.jpg";